import { CATALOGUE_MODE } from "@constants";

import React, { useEffect, useRef } from "react";

const VideoSlide = ({
    item,
    isActive,
}: {
    item: StandbyScreenItemType;
    isActive: boolean;
}): JSX.Element => {
    const videoRef = useRef<HTMLVideoElement>(null);

    // Reset video when slide becomes inactive
    useEffect(() => {
        if (isActive && videoRef.current) {
            videoRef.current.play();
        }
        return () => {
            if (videoRef.current) {
                videoRef.current.pause();
                videoRef.current.currentTime = 0;
            }
        };
    }, [isActive]);

    return (
        <video
            ref={videoRef}
            autoPlay={true}
            muted
            playsInline
            className="h-100 w-100"
            style={{
                objectFit:
                    process.env.REACT_APP_MODE === CATALOGUE_MODE
                        ? "contain"
                        : "fill",
            }}
        >
            <source src={item.content} type="video/mp4" />
        </video>
    );
};

export default VideoSlide;
